import { useKeycloak } from '@react-keycloak/web';
import './style.css';
import { jwtDecode } from 'jwt-decode';
import {
  setUserSession,
  getAcl,
  getToken,
  removeUserSession,
  fetchLog,
  getMenuAccess,
  getFirstAccessibleMenuPath,
} from '../../utils/common';
import logger from '../../utils/logger';

const LoginButton = () => {
  const { keycloak } = useKeycloak();
  const token = getToken();
  const navconficCustom = [];
  const navConfig = [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      namaroute: 'dashboard',
    },
    {
      title: 'users',
      path: '/dashboard/user',
      namaroute: 'user',
    },
    {
      title: 'actions',
      path: '/dashboard/action',
      namaroute: 'action',
    },
    {
      title: 'alerts',
      path: '/dashboard/alert',
      namaroute: 'alert',
    },
    {
      title: 'reports',
      path: '/dashboard/report',
      namaroute: 'report',
    },
    {
      title: 'information',
      path: '/dashboard/information',
      namaroute: 'information',
    },
    {
      title: 'Dataset Map',
      path: '/dashboard/dataset',
      namaroute: 'data_set',
    },
    {
      title: 'About',
      path: '/dashboard/about',
      namaroute: 'about',
    },
    {
      title: 'Activity Log',
      path: '/dashboard/activitylogs',
      namaroute: 'activity',
    },
    {
      title: 'logout',
      path: '/login',
      namaroute: 'logout',
    },
  ];

  return (
    <button
      className="button-93"
      onClick={async () => {
        if (!keycloak.authenticated) {
          keycloak.login({
            redirectUri: globalThis.location.origin,
            scope: 'openid profile email offline_access', // Add offline_access scope
          });
          return;
        }

        const { token } = keycloak;
        if (!token) {
          logger.error('No token available');
          return;
        }

        try {
          const decoded = jwtDecode(token);
          const roles = decoded.resource_access.smartshield?.roles?.[0];
          if (!roles) {
            alert('Please contact your administrator to get access to the system');
            fetch(
              `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/logout?id_token_hint=${keycloak.idToken}&post_logout_redirect_uri=${globalThis.location.origin}`
            ).then(async () => {
              globalThis.location.href = `${globalThis.location.origin}`;
            });
            return;
          }
          const fullname = decoded.family_name;
          const { email } = decoded;

          setUserSession(keycloak.token, keycloak.refreshToken, email, roles, fullname);

          let acl = getAcl();
          const maxRetries = 10;
          let attempts = 0;

          while ((!acl || acl.length === 0) && attempts < maxRetries) {
            attempts += 1;
            await new Promise((resolve) => setTimeout(resolve, 1000));
            acl = getAcl();
          }

          if (!acl || acl.length === 0) {
            logger.error('Failed to retrieve ACL data after multiple attempts');
            try {
              await getMenuAccess(true);
              acl = getAcl();
            } catch (error) {
              logger.error('Failed to fetch permissions:', error);
              keycloak.login({
                redirectUri: globalThis.location.origin + '/dashboard/app',
                scope: 'openid profile email offline_access',
              });
              return;
            }
          }

          // Use helper function to get first accessible menu (matches sidebar logic exactly)
          const redirectPath = getFirstAccessibleMenuPath(acl);

          keycloak.login({
            redirectUri: globalThis.location.origin + redirectPath,
            scope: 'openid profile email offline_access', // Add offline_access scope
          });
        } catch (error) {
          logger.error('Error during token decoding or login process:', error);
        }
      }}
    >
      {token ? 'Dashboard' : 'Login'}
    </button>
  );
};

const LogoutButton = () => {
  const { keycloak } = useKeycloak();
  let setClick = false;
  return (
    <button
      className="button-94"
      disabled={setClick}
      onClick={() => {
        setClick = true;
        setTimeout(() => {
          fetchLog(`${globalThis.REACT_APP_API_PURE}user/logout`);
          sessionStorage.clear();
          keycloak.login();
          removeUserSession();
        }, 2000);
      }}
    >
      Logout
    </button>
  );
};

export { LoginButton, LogoutButton };
